import React, { ReactElement } from 'react'
import { Card } from 'ktr-materialui-react';
import * as Utils from '../../Utils';
import { useIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import  Values from '../../react-intl/FMValues';
import KTR203IMG from '../../images/KTR203.jpg';

interface Props {
    className?: string
}


export default function KTR203(props: Props): ReactElement {
    const { formatMessage: f } = useIntl();
     

    return (
        <div>  
        <Card
            className={props.className}
            heading="KTR 203"
            banner="370 Nm - 487.000 Nm"
            content={<FormattedMessage id='app.ktr203.content' values={Values}/>}
            buttonText={f({id:'app.ktr203.button'})}
            imageURL={KTR203IMG}
            onClick={(event) => Utils.openLink(Utils.WEBSITEURL + "KTR203")}
        />
        </div>
    )
}
